import { useSelector } from 'react-redux';

import type { FeatureName } from 'constant/features';
import { RootState } from 'redux/store';
import { hasFeature } from 'utils/features';

export function useHasFeature(name: FeatureName): boolean {
    const enabledFeatures = useSelector((state: RootState) => state.user.entity.enabled_features);
    return hasFeature(enabledFeatures, name);
}

export default useHasFeature;
